import applyBulkItemActionOperation from 'owa-service/lib/operation/applyBulkItemActionOperation';
import { getJsonRequestHeader } from 'owa-service/lib/Utils';
/**
 * Always move to Focused or Other Service
 * @param sourceFolderId the source folderId
 * @param emailAddresses emailaddresses
 * @param itemPropertytoUpdate the item property to update
 * @return the ApplyBulkItemActionResponse
 */
export function alwaysMoveToFocusedOtherService(sourceFolderId, emailAddresses, itemPropertytoUpdate) {
    var requestBody = {
        SourceFolderId: sourceFolderId,
        EmailAddresses: emailAddresses,
        ActionType: 3 /* MoveToFocusedOther */,
        ItemPropertyToUpdate: itemPropertytoUpdate,
    };
    return applyBulkItemActionOperation({
        Header: getJsonRequestHeader(),
        Body: requestBody,
    }).then(function (response) {
        return response.Body;
    });
}
//# sourceMappingURL=alwaysMoveToFocusedOtherService.js.map